// Import from NPM
// -------------------------------------
import React from "react";
import { NavLink } from "react-router-dom";
import { Menu, Icon, Dropdown, Image } from "semantic-ui-react";
import _ from "lodash";
import "@styles/navbars.scss";
import "@styles/icomoon.css";
import { darkStyle } from "@utilities/helpers";

import { useTranslation } from "react-i18next";
import { settings } from "@config/settings/app.settings";

export default function BottomMenu(props) {
    const { t } = useTranslation("common");

    // ========================= Render Function =================================
    return (
        <Menu
            className="qd-bottom-menu"
            fluid
            widths={settings.menu.core.length}
            icon="labeled"
            style={darkStyle(settings.colors.main, "to top")}
        >
            {_.map(_.initial(settings.menu.core), (mainlink, index) => {
                return (
                    <Menu.Item
                        name={mainlink.transCode}
                        key={`main-menu-link-${index}`}
                    >
                        <NavLink to={mainlink.link} className="mobile-link">
                            <i className={`icon icm icon-${mainlink.icon}`} />
                            <br />
                            {t(`sidebar.mobile.${mainlink.transCode}`)}
                        </NavLink>
                    </Menu.Item>
                );
            })}
            <Menu.Item name="More">
                <Dropdown
                    trigger={
                        <span
                            key={`main-menu-link-more`}
                            className="more mobile-link"
                        >
                            <Icon name="ellipsis vertical" />
                            <br />
                            {t(`sidebar.more`)}
                        </span>
                    }
                    upward
                    direction="left"
                >
                    <Dropdown.Menu>
                        {_.map(settings.menu.quick, (quicklink, index) => {
                            return (
                                <Dropdown.Item key={`quick-menu-link-${index}`}>
                                    <NavLink
                                        to={quicklink.link}
                                        className="quick-link"
                                    >
                                        <Image
                                            src={t(
                                                `sidebar.quick.${quicklink.transCode}`
                                            )}
                                        />
                                    </NavLink>
                                </Dropdown.Item>
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
        </Menu>
    );
}
